import { render, staticRenderFns } from "./TaskTypeDisplay.vue?vue&type=template&id=90eece2c&scoped=true&"
import script from "./TaskTypeDisplay.vue?vue&type=script&lang=js&"
export * from "./TaskTypeDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90eece2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90eece2c')) {
      api.createRecord('90eece2c', component.options)
    } else {
      api.reload('90eece2c', component.options)
    }
    module.hot.accept("./TaskTypeDisplay.vue?vue&type=template&id=90eece2c&scoped=true&", function () {
      api.rerender('90eece2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Plannings/TaskTypeDisplay.vue"
export default component.exports